<script>
    import {goto} from '$app/navigation';
    import {query} from '$lib/store.js';

    import CreateDossierButton from './CreateDossierButton.svelte';
    import search_icon from './search.svg';

    // '/app' or '/app/agenda'
    export let location;
</script>

<!-- If the query is empty, then don't include the '?zoek' parameter in the URL  -->
<form id="search-bar" on:submit|preventDefault={() => {if (!$query.trim()) {goto(location, {keepFocus: true})} else {goto(`${location}?zoek=${$query}`, {keepFocus: true})}}}>
    <input bind:value={$query} name="zoek" type="search" placeholder="Zoek naar onderwerpen">
    <div class="form-actions">
        <button id="search" class="btn btn-round bg-gold" type="submit">
            <img src={search_icon} alt="Zoek" title="Zoek" width="24.52" height="24.88">
        </button>

        <CreateDossierButton display='d-none d-lg-block' --margin='3px 10px 0 0'/>
    </div>
</form>

<style lang="scss">
    #search-bar {
        display: flex;
        background-color: white;
        height: 50px;
        padding: 1px 0 1px 30px;
        margin-bottom: 26px;
        border: 1px solid var(--light-blue-color5);
        border-radius: 100px;

        input {
            flex-grow: 2;
            border: none;

            &:focus {
                outline: none;
            }

            &:placeholder-shown {
                font-style: italic;
            }
        }
    }

    #search {
        position: relative;
        top: -2px;
        height: 50px;
        width: 50px;
        box-shadow: none;
        outline: revert;
    }

    @media (max-width: 991px) {
        #search-bar {
            margin-bottom: 20px;
        }
    }
</style>
